<ng-container *transloco="let t">
<div class="post d-flex flex-column-fluid">
  <div class="container">
    @if (!readyToSign && !showDocumentList) {
      <div class="card" style="margin-top: 15px; height: 97vh">
        <div class="card-body p-0 esign-container">
          <div class="card-px"
            [ngClass]="{'eConsent-container': !isLoading && needEconsent && !alert, 'eConsent-container-alert': !isLoading && needEconsent && alert}">
            @if (alert) {
              <ng-container>
                <div *ngTemplateOutlet="alertTemplate"></div>
              </ng-container>
            }
            @if (isLoading) {
              <ng-container>
                <div *ngTemplateOutlet="progressTemplate"></div>
              </ng-container>
            }
            @if (!isLoading && needToValidateLoan) {
              <ng-container>
                <div *ngTemplateOutlet="askForInfoTemplate"></div>
              </ng-container>
            }
            @if (!isLoading && needEconsent) {
              <ng-container>
                <div *ngTemplateOutlet="econsentTemplate"></div>
              </ng-container>
            }
          </div>
        </div>
      </div>
    }
    @if (showDocumentList && !readyToSign) {
      <div class="card" style="margin-top: 15px; height: 97vh">
        <div class="card-body p-0 esign-container">
          <div class="card-px">
            @if (alert) {
              <ng-container>
                <div *ngTemplateOutlet="alertTemplate"></div>
              </ng-container>
            }
            @if (!isLoading) {
              <ng-container>
                <div *ngTemplateOutlet="documentListTemplate"></div>
              </ng-container>
            }
            @if (isLoading) {
              <ng-container>
                <div *ngTemplateOutlet="progressTemplate"></div>
              </ng-container>
            }
          </div>
        </div>
      </div>
    }

    @if (!isLoading && readyToSign) {
      <ng-container>
        <div *ngTemplateOutlet="esignTemplate"></div>
      </ng-container>
    }
  </div>
</div>

<ng-template #alertTemplate>
  <div class="alert bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
    <i class="fas fa-exclamation-triangle fs-2hx text-danger me-4 mb-5 mb-sm-0"></i>
    <div class="d-flex flex-column pe-0 pe-sm-10">
      <h5 class="mb-1">{{ alert.title }}</h5>
      <span>{{ alert.message }}</span>
    </div>
  </div>
</ng-template>

<ng-template #progressTemplate>
  <div class="d-flex">
    <div class="spinner-border m-5 text-success" style="width: 2.75rem; height: 2.75rem" role="status"></div>
    <h4 style="margin-top: 24px">{{ loadingMessage }}</h4>
  </div>
</ng-template>

<ng-template #askForInfoTemplate>
  <form #loanValidationForm="ngForm" class="form" novalidate id="loanValidationForm" name="loanValidationForm">
    <div class="info-entry-container">
      <div class="fv-row mb-3">
        <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
          <span>{{ t('portal.eSign.enterPropertyZip') }}</span>
        </label>
        <div class="position-relative">
          <input style="width: 300px" #enteredZipCode="ngModel" type="text" [dropSpecialCharacters]="false"
            [validation]="false" [pattern]="zipCodePattern" [mask]="zipCodeMask" [placeholder]="zipCodePlaceHolder"
            [name]="'zipCode'" [id]="'zipCode'" [required]="isPropertyZipRequired" [(ngModel)]="subjectPropertyZipCode"
            (keydown.enter)="onSubmitClicked()" class="form-control form-control-solid" [ngClass]="{
            'is-invalid':
              enteredZipCode && enteredZipCode.touched && enteredZipCode.invalid
          }" />
          <div class="invalid-feedback">{{ t('portal.eSign.pleaseEnterZip') }}</div>
        </div>
      </div>
      @if (userScope === 'Borrower' && isLast4DigitsOfSsnRequired) {
        <div class="fv-row mb-3">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span>{{ t('portal.eSign.enterLast4Ssn') }}</span>
          </label>
          <div class="position-relative">
            <input class="form-control form-control-solid" [showMaskTyped]="true" [(ngModel)]="borrowerSsn"
              #socialSecNum="ngModel" [dropSpecialCharacters]="false" [mask]="ssnMask" [pattern]="ssnPattern"
              [placeholder]="t('portal.eSign.last4SsnPlaceholder')" name="ssn" id="ssn" (keydown.enter)="onSubmitClicked()"
              [required]="isLast4DigitsOfSsnRequired" [ngClass]="{
              'is-invalid':
                socialSecNum && socialSecNum.touched && socialSecNum.invalid
            }" />
            <div class="invalid-feedback">
              {{ t('portal.eSign.pleaseEnterLast4Ssn') }}
            </div>
          </div>
        </div>
      }
      <div class="fv-row">
        <a (click)="onSubmitClicked()" class="btn btn-success">{{ t('common.submit') }}</a>
      </div>
    </div>

  </form>
</ng-template>

<ng-template #esignTemplate>
  <div style="width: 100%; height: 100vh">
    @if (signerViewUrl &&
        (!documentSigningVendor || documentSigningVendor === 'DocuSign' || documentSigningVendor === 'SignNow')) {
      <iframe #signingIframe [src]="signerViewUrl" width="100%" height="100%">
      </iframe>
    }

    @if (signerViewUrl && documentSigningVendor === 'EncompassPOS') {
      <iframe #signingIframe [src]="signerViewUrl" width="100%"
        height="100%" sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"
        allow="camera; microphone; display-capture; fullscreen">
      </iframe>
    }

    @if (signerViewUrl && documentSigningVendor === 'DocMagic') {
      <iframe
        #signingIframe
        sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"
        allow="camera; microphone; display-capture; fullscreen" [src]="signerViewUrl" width="100%" height="100%">
      </iframe>
    }
  </div>
</ng-template>

<ng-template #econsentTemplate>
  <iframe id="econsent-text-iframe" sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"
    allow="camera; microphone; display-capture; fullscreen" width="100%" height="100%">
  </iframe>
  <h2 class="anchor fw-bolder my-2" id="layout" style="margin-left: 29%;">
    <span> {{ t('portal.eSign.consentToDoBusinessElectronically') }} </span>
  </h2>
  <div class="col-lg-12 mb-3" style="margin-left: 29%;">
    <div class="d-flex align-items-center mt-3">
      <form #loanValidationForm="ngForm" class="form" novalidate id="loanValidationForm" name="loanValidationForm">
        <label class="form-check form-check-inline form-check-solid me-5">
          <input class="form-check-input" required name="consentToDoBusinessCheckbox" #consent="ngModel" [ngClass]="{
              'is-invalid': consent && consent.touched && consent.invalid
            }" [(ngModel)]="econsentGiven" type="checkbox" />
          <span class="fw-bold ps-2 fs-6 required">{{ t('portal.eSign.iWeConsent') }}</span>
          <div class="invalid-feedback">{{ t('portal.eSign.consentRequired') }}</div>
        </label>
      </form>
    </div>
  </div>
  <a (click)="onEconsentSubmitClicked()" class="btn btn-success" style="margin-left: 29%;">{{ t('common.submit') }}</a>
</ng-template>

<ng-template #documentListTemplate>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        @if (!allDocsSigned) {
          <div class="card-title mb-4 mb-md-5 text-center">
            <h3 class="fw-bolder">{{ t('portal.eSign.documentsToSign') }}</h3>
            <p class="text-muted fs-6">{{ t('portal.eSign.selectDocumentToSign') }}</p>
          </div>
        }
        @if (allDocsSigned) {
          <div class="card-title mb-4 mb-md-5 text-center">
            <h3 class="fw-bolder">{{ t('portal.eSign.allDocsSigned') }}</h3>
            <div class="mt-3 alert alert-success" style="font-size:1.1rem;">
              <i class="fas fa-check-circle text-success fs-3 fs-md-1 me-2"></i>{{ t('portal.eSign.canCloseBrowser') }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="documents-list">
    @for (order of _ordersToSign; track order.signingOrder; let i = $index) {
      <div class="card shadow-sm mb-3 mb-md-4"
        [ngClass]="{'border border-success bg-light-success': _finishedOrderIds.includes(order.signingOrder), 'not-signed-card': !_finishedOrderIds.includes(order.signingOrder)}"
        [style.cursor]="!_finishedOrderIds.includes(order.signingOrder) ? 'pointer' : 'default'"
        [style.pointerEvents]="_finishedOrderIds.includes(order.signingOrder) ? 'none' : 'auto'"
        (click)="!_finishedOrderIds.includes(order.signingOrder) && selectDocument(i)">
        <div class="card-body p-4 p-sm-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start mb-3">
            <h4 class="card-title mb-2 mb-sm-0 fs-4 fs-sm-5">{{ order.orderTitle || 'Document ' + (i + 1) }}</h4>
            @if (order.orderDate) {
              <span class="badge bg-light text-dark fw-bold">{{ order.orderDate | date }}</span>
            }
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="card-text">
              @if (_finishedOrderIds.includes(order.signingOrder)) {
                <span class="badge bg-success me-2">{{ t('portal.eSign.signed') }}</span>
              }
              @if (!_finishedOrderIds.includes(order.signingOrder)) {
                <span class="badge bg-primary me-2">{{ t('portal.eSign.notSigned') }}</span>
              }
            </div>
            <div>
              @if (_finishedOrderIds.includes(order.signingOrder)) {
                <i
                  class="fas fa-check-circle text-success fs-3 fs-md-1"></i>
              }
              @if (!_finishedOrderIds.includes(order.signingOrder)) {
                <i
                  class="fas fa-file-signature text-primary fs-3 fs-md-1"></i>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>
</ng-container>
